<template>
  <div class="container-fluid pt-3">
    <h3 class="mb-3">Лист покупок</h3>

    <div class="card shadow mb-3 border-top-secondary">
      <ul class="list-group list-group-flush">
        <li class="list-group-item"
            v-for="(item, tobuyKey) in tobuy"
            :key="tobuyKey">
          <ShopItem :prescription="item" />
        </li>
      </ul>

      <div v-if="tobuy.length === 0" class="p-3">
        Список пуст
      </div>
    </div>

    <h3 class="mb-3">Куплено</h3>

    <div class="card shadow mb-3 border-top-secondary">
      <ul class="list-group list-group-flush">
        <li class="list-group-item"
            v-for="(item, boughtKey) in bought"
            :key="boughtKey">
          <ShopItem :prescription="item" />
        </li>
      </ul>

      <div v-if="bought.length === 0" class="p-3">
        Список пуст
      </div>
    </div>
  </div>
</template>

<script>
  import ShopItem from './ShopItem';

  export default {
    name: 'ShopList',

    props: ['drugPrescriptions'],

    components: { ShopItem },

    data() {
      return {
        itemId: '',
      };
    },

    computed: {
      tobuy() {
        return this.drugPrescriptions.filter(item => item.bought === false);
      },

      bought() {
        return this.drugPrescriptions.filter(item => item.bought === true);
      },
    },

    methods: {
    },
  };
</script>
